
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <div class="content">
      <div class="page_container">
      <div class="link_block"  @click="sendAlcoholCheck('2')" id="no">
          <ons-ripple ></ons-ripple>
      </div>
      <div class="link_block"  @click="sendAlcoholCheck('1')" id="yes">
          <ons-ripple ></ons-ripple>
      </div>
        <img class="bg_img" src="../assets/demo/img/demo_opening.jpg" alt="">
      </div>
    </div>
    
  </v-ons-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'blank',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'ShopCode',
      'ShopIP',
      'ApiVersion',
      'PortNo',
      'SlipNo',
      'SlipDate',
      'LinePageEnabled',
      ]),
  },
  methods: {
    ...mapActions([
      'SendAlcoholCheck',
      'navigatePage',
      'navigateWPPage',
      'setSessionToken',
    ]),
    sendAlcoholCheck(answer){
      this.SendAlcoholCheck(answer)
      .then(()=>{
        if(this.LinePageEnabled=='true'){
          this.navigatePage('line_friend') //WP単独ページへ遷移
        }else{
          this.setSessionToken()
          this.navigateWPPage('menu_top')
        }
        
      }).catch(error=>{
        //アルコールチェック失敗
        if(this.LinePageEnabled=='true'){
          this.navigatePage('line_friend') //WP単独ページへ遷移
        }else{
          this.setSessionToken()
          this.navigateWPPage('menu_top')
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
/*
.content.start{
    padding: 20% 10% 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: url(../assets/img/home_bg.jpg) no-repeat!important;
    background-size: cover!important; 
    background-position: center;
    color: $base-font-color;
  }
  */
.content{
    padding: 0;
  }
.logo{
  margin-bottom: 30px;
}
.notice{
  text-align: center;
  margin-bottom: 20px;
}
.button_block{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn_alcohol_check{
  font-size: 14px;
  width: 48%;
  overflow: visible;
  margin: 5px;
  text-align: center;
  color: $base-font-color;
  border-color: $base-font-color;
}

#no{
  top: calc(100vw*1090/750);
  left: calc(100vw*84/750);
  width: calc(100vw*580/750);
  height: calc(100vw*120/750);
}
#yes{
  top: calc(100vw*926/750);
  left: calc(100vw*84/750);
  width: calc(100vw*580/750);
  height: calc(100vw*120/750);
}
.link_block{
  //border: 2px solid blue;
}
/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/StartPage.vue